const tabsContainer = document.querySelector('.tabs-content')
const tabsContent = document.querySelectorAll('.tabs-content .tab')
const tablist = document.querySelector('.tabbed-content .tabs')
const buttons = document.querySelectorAll('.tabbed-content .tabs button')

if (!tabsContainer || !buttons.length) return

function activateTab(index) {
	const button = buttons[index]
	const tabContent = Array.from(tabsContent).find(
		(panel) => panel.dataset.tab === button.dataset.tab
	)
	if (!tabContent) return

	buttons.forEach((btn, i) => {
		const isSelected = i === index
		btn.classList.toggle('active', isSelected)
		btn.setAttribute('aria-selected', isSelected)
	})
	tabsContent.forEach((panel) => panel.classList.remove('active'))
	tabContent.classList.add('active')
	tabsContainer.style.setProperty('--container-height', `${tabContent.scrollHeight}px`)
}

buttons.forEach((button) => {
	button.addEventListener('click', () => {
		const index = parseInt(button.dataset.index, 10)
		if (!Number.isNaN(index)) activateTab(index)
	})
})

tabsContainer.addEventListener('focusin', (e) => {
	const tabPanel = e.target.closest('.tab')
	if (!tabPanel) return
	const tabId = tabPanel.dataset.tab
	const matchingButton = Array.from(buttons).find((btn) => btn.dataset.tab === tabId)
	if (matchingButton) {
		const index = parseInt(matchingButton.dataset.index, 10)
		if (!Number.isNaN(index)) activateTab(index)
	}
})

if (tablist) {
	tablist.addEventListener('keydown', (e) => {
		const current = Array.from(buttons).indexOf(document.activeElement)
		if (current === -1) return
		const len = buttons.length
		let next = -1
		if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
			e.preventDefault()
			next = (current + 1) % len
		} else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
			e.preventDefault()
			next = (current - 1 + len) % len
		} else if (e.key === 'Home') {
			e.preventDefault()
			next = 0
		} else if (e.key === 'End') {
			e.preventDefault()
			next = len - 1
		}
		if (next !== -1) {
			activateTab(next)
			buttons[next].focus()
		}
	})
}

tabsContent.forEach((tabContent) => {
	if (tabContent.classList.contains('active')) {
		tabsContainer.style.setProperty(
			'--container-height',
			`${tabContent.scrollHeight}px`
		)
	}
})

window.addEventListener('resize', () => {
	tabsContent.forEach((tabContent) => {
		if (tabContent.classList.contains('active')) {
			tabsContainer.style.setProperty('--container-height', 'fit-content')
			tabsContainer.style.setProperty(
				'--container-height',
				`${tabContent.scrollHeight}px`
			)
		}
	})
})
